<template>
  <div>
    <div :class=" maxWidth ? 'select-box ajustar' :'select-box'">
      <div :id="claseId" :class="active ? 'active' : ''" class="options-container">
        <div  class="option" v-for="item in items" :key="item.value" @click="handleSelect(item)">
          <input   type="radio" class="radio" :id="item.value" name="category" />
          <label  :class="item.text" >{{ item.text }}</label>
        </div>
      </div>
      <div :id="claseId" class="selected"  :class=" disabled ? 'disabled' : selectedItem.text " @click="handleActive" >{{ selectedItem.text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default:()=>  [
        { value: 0, text: "opcion 1" },
        { value: 1, text: "opcion 2" },
        { value: 2, text: "opcion 3" },
        { value: 3, text: "opcion 4" },
      ],
    },
    disabled:{
      type:Boolean,
      default:false
    },
    claseId:{
      type:String,
      default:''
    },
    startValue:{
      type:Number,
      default:-2,
    },
    placeholder:{
      type:String,
      default:"Seleccione"
    },
    maxWidth:{
      type:Boolean,
      default:false
    }

  },
  emits:["status"],
  data() {
    return {
      active: false,
      selectedItem:{value:0,text:this.placeholder}
    };
  },
  methods:{
    handleActive(){
      if(this.disabled) return this.active = false
        this.active = !this.active
    },
    handleSelect(item){
       this.selectedItem = item
       this.active = false
       this.$emit("status",item.value)
    },
    selectStartValue(){
    if(this.startValue == -2) return
    const options = this.items.filter((i)=>i.value == this.startValue )
    this.handleSelect(options[0])
  },
  },
  mounted(){
    this.selectStartValue()
  },

  watch:{
    selectedItem(value){
        console.log(value)
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  box-sizing: border-box;
}

.Cancelar{
color: #FF3737 !important;
}
.Pendiente{
  color: #0A4F9C !important;
}
.Asistio{
  color: #2196F3 !important;
}
.No{
  color: #FB8C00 !important;
}

.disabled{
font: normal normal bold 14px/19px Open Sans;
letter-spacing: 0px;
color: #C4C4C4 !important;
background: #F7F7F7 0% 0% no-repeat padding-box !important;
border: 1px solid #C4C4C4 !important;
border-radius: 4px;
filter: grayscale(100%) !important;
}
.select-box {
  display: flex;
  flex-direction: column;
  /* width: 100%; */
  width: 140px;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  position: relative;
}

.select-box.ajustar{
  width: 100% !important;
}
.select-box .options-container {
  background-color: #ffff;
  border: 1px solid #0a4f9c;
  max-height: 0;
  width: 100%;
  opacity: 0;
  transition: all 0.4s;
  border-radius: 4px;
  overflow: hidden;
  order: 1;
  position: absolute;
  top: 35px;
  z-index: 700;
}


#dashboard{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 10px;
font: normal normal 600 16px/22px Open Sans;
letter-spacing: 0px;
color: #616161;
border: 1px solid #00000029;
}

.selected {
  background-color: #ffff;
  border: 1px solid #0a4f9c;
  border-radius: 4px;
  /* margin-bottom: 4px; */
  color: #0a4f9c;
  order: 0;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  /* z-index: 600; */
  text-align: start;
}

.selected::after {
  content: "";
  background-image: url("../../assets/imgs/Arrow.svg");
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 15px;
  top: 10px;
  right: 10px;
  transition: all 0.4s;
}

.select-box .option,
.selected {
  padding: 4px 8px;
  cursor: pointer;
}

/* .selected + .options-container.active{
    border-bottom: none;
} */

.select-box .options-container.active {
  max-height: 240px;
  opacity: 1;
  overflow-y: scroll;
  /* border-top: none; */
}

.select-box .options-container.active + .selected::after{
    transform: rotateX(180deg);
    top: -10px;
}

/* .select-box .options-container::-webkit-scrollbar {
  width: 8px;
  background-color: #0d141f;
  border-radius: 0 8px 8px 0;
}

.select-box .options-container::-webkit-scrollbar-thumb {
  background-color: #525861;
  border-radius: 0 8px 8px 0;
} */

.select-box .option:hover {
  background-color: #e5e5e5;
}

.select-box label {
  cursor: pointer;
}

.select-box .option .radio {
  display: none;
}
</style>
